import React from 'react';
import styles from './Grid.module.css';

export default ({
  href, image, title, titleSize, description, span, spanMobile, children,
}) => {
  let titleComponent;
  switch (titleSize) {
    case 'h1':
      titleComponent = (<h1 className={styles.title}>{title}</h1>);
      break;
    case 'h2':
      titleComponent = (<h2 className={styles.title}>{title}</h2>);
      break;
    case 'h3':
    default:
      titleComponent = (<h3 className={styles.title}>{title}</h3>);
      break;
    case 'h4':
      titleComponent = (<h4 className={styles.title}>{title}</h4>);
      break;
    case 'h5':
      titleComponent = (<h5 className={styles.title}>{title}</h5>);
      break;
    case 'h6':
      titleComponent = (<h6 className={styles.title}>{title}</h6>);
      break;
  }

  const card = (
    <div
      style={{
        '--span': span || 1,
        '--spanMobile': spanMobile || 1,
      }}
      className={styles.gridCard}
    >
      {image && (<img className={styles.gridImage} src={image} alt={title} />)}
      {title && titleComponent}
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </div>
  );

  // If has no link, just return the card
  if (!href) return card;

  // It has a link and we need to wrap it
  return (<a className={styles.gridCard} href={href}>{card}</a>);
};
